import { LandingPage } from './LandingPage'

const Home = () => {
  return <LandingPage />
}

export default Home